var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c('router-view',{staticStyle:{"padding-bottom":"100px"}})],1),_c('NavBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }